module.exports = __webpack_public_path__ + "media/images/questionnaire_overview/launch-de135dc638012298c772598a82d2e4a8.svg";